import type { Tour } from '../tour-types';

/**
 * Implementation: winners that still need building. The empty page is marked as a
 * first-run state, so the tour waits for content. The row anchors (winner, mark,
 * screenshots, code, actions) are on the first row of the first section that has rows,
 * which is the queue when it has any. Screenshots drop out when that row has none.
 */
export const implementationTour: Tour = {
  key: 'implementation',
  version: 1,
  routes: ['/experiments/implementation'],
  steps: [
    {
      anchor: 'implementation-toolbar',
      placement: 'bottom',
      title: 'Search and export',
      body: 'Search every section at once, or switch on Implemented Only to see what is done. Export CSV downloads exactly what the page is showing.',
    },
    {
      anchor: 'implementation-queue',
      placement: 'bottom',
      title: 'Needs implementation',
      body: 'Experiments where a variant beat the control and nothing is live yet. This is the work to hand to your developers.',
    },
    {
      anchor: 'implementation-winner',
      title: 'Winning variant',
      body: 'The variant to build, with the goal it won on and by how much. Hover it to see how each goal came out, since conversions and revenue can disagree.',
    },
    {
      anchor: 'implementation-mark',
      requires: 'experiments:implement',
      title: 'Mark as implemented',
      body: 'Tick it once the change is built into the site, and it moves to Marked as implemented. If the experiment is still running, you are asked whether to end it.',
    },
    {
      anchor: 'implementation-screenshots',
      placement: 'left',
      title: 'Before and after',
      body: 'Screenshots of the control and of the winning variant, so whoever builds it can see the change without opening the experiment.',
    },
    {
      anchor: 'implementation-code',
      placement: 'left',
      title: 'Variant code',
      body: 'The code behind the winning variant, to copy into the site or pass to whoever builds it.',
    },
    {
      anchor: 'implementation-actions',
      placement: 'left',
      requires: 'experiments:implement',
      title: 'Email the details',
      body: 'Email Details sends a developer a link to everything needed to build this change, with a note from you. Export CSV here downloads just this experiment.',
    },
    {
      anchor: 'implementation-deployed',
      placement: 'top',
      title: 'Deployed',
      body: 'A variant that is already live on the site, so there is nothing to build. It stays listed so its code and screenshots are easy to find.',
    },
    {
      anchor: 'implementation-implemented',
      placement: 'top',
      title: 'Marked as implemented',
      body: 'Everything someone has ticked as built, kept apart so the queue only holds open work. Untick one if it was marked by mistake.',
    },
  ],
};
